// Both ------------------------
import type { ReactElement } from 'react';

const authenticatedPathNames = [
  // 'SETTINGS',
  'LOGOUT'
] as const;

const authenticatedPathUrls = [
  // '/settings',
  '/logout'
] as const;

const unAuthenticatedPathNames = [
  'LOGIN',
  'SMS_VERIFICATION',
  'RESET_PASSWORD',
  'CONFIRM_RESET_PASSWORD',
  'LOGOUT',
  'NOT_FOUND_PAGE'
] as const;

const unAuthenticatedPathUrls = [
  '/',
  '/login',
  '/sms-verification',
  '/reset-password',
  '/confirm-reset-password',
  '/logout',
  '*'
] as const;

// Merchant -----------------------

const merchantAuthenticatedPathNames = [
  'APPLICATIONS',
  'SNPL',
  'PAYMENT_ASSIST',
  'COURSES',
  'REPORTING'
] as const;

const merchantAuthenticatedPathUrls = [
  '/applications',
  '/snpl',
  '/payment-assist',
  '/courses',
  '/reporting'
] as const;

const merchantAdminPathNames = ['USERS', 'USEFUL_LINKS'] as const;

const merchantAdminPathUrls = ['/admin-settings', '/onboard-merchant'] as const;

// Platform -----------------------

const platformUserAuthenticatedPathNames = ['ACCOUNTS'] as const;

const platformUserAuthenticatedPathUrls = ['/accounts'] as const;

const platformAdminPathNames = ['PLATFORM_USERS'] as const;

const platformAdminPathUrls = ['/platform/users'] as const;

// TODO: add Admin, Merchant, Sales etc... pathNames and pathUrls
const allPathNames = [
  ...authenticatedPathNames,
  ...merchantAuthenticatedPathNames,
  ...platformUserAuthenticatedPathNames,
  ...unAuthenticatedPathNames,
  ...merchantAdminPathNames,
  ...platformAdminPathNames
] as const;

const allPathUrls = [
  ...unAuthenticatedPathUrls,
  ...authenticatedPathUrls,
  ...merchantAuthenticatedPathUrls,
  ...platformUserAuthenticatedPathUrls,
  ...merchantAdminPathUrls,
  ...platformAdminPathUrls
] as const;

type TPath = {
  readonly title: string;
  readonly path: string;
  readonly icon: ReactElement;
};

type TMerchantPathAdmin = {
  [name in (typeof merchantAdminPathNames)[number]]: TPath;
};

type TPlatformPathAdmin = {
  [name in (typeof platformAdminPathNames)[number]]: TPath;
};

type TPathAuthenticated = {
  [name in (typeof authenticatedPathNames)[number]]: TPath;
};

type TPathMerchantAuthenticated = {
  [name in (typeof merchantAuthenticatedPathNames)[number]]: TPath;
};

type TPathPlatformUserAAuthenticated = {
  [name in (typeof platformUserAuthenticatedPathNames)[number]]: TPath;
};

type TPathUnauthenticated = {
  [name in (typeof unAuthenticatedPathNames)[number]]: TPath;
};

type TAllPaths = {
  [name in (typeof allPathNames)[number]]: TPath;
};

const merchantAdminPaths: TMerchantPathAdmin = {
  USERS: {
    title: 'Users',
    path: '/users',
    icon: <span className="material-symbols-rounded">person</span>
  },
  USEFUL_LINKS: {
    title: 'Useful links',
    path: '/useful-links',
    icon: <span className="material-symbols-rounded">link</span>
  }
} as const;

const platformAdminPaths: TPlatformPathAdmin = {
  PLATFORM_USERS: {
    title: 'Users',
    path: '/platform/users',
    icon: <span className="material-symbols-rounded">person</span>
  }
} as const;

const unAuthenticatedPaths: TPathUnauthenticated = {
  LOGIN: {
    title: 'Login Page',
    path: '/login',
    icon: <span className="material-symbols-rounded">attachment</span>
  },
  SMS_VERIFICATION: {
    title: 'SMS Verification',
    path: '/sms-verification',
    icon: <span className="material-symbols-rounded">attachment</span>
  },
  RESET_PASSWORD: {
    title: 'Reset Password',
    path: '/reset-password',
    icon: <span className="material-symbols-rounded">attachment</span>
  },
  CONFIRM_RESET_PASSWORD: {
    title: 'Confirm Reset Password',
    path: '/confirm-reset-password',
    icon: <span className="material-symbols-rounded">attachment</span>
  },
  LOGOUT: {
    title: 'Logout',
    path: '/logout',
    icon: (
      <span id="logout-button" className="material-symbols-rounded">
        attachment
      </span>
    )
  },
  NOT_FOUND_PAGE: {
    title: 'Not Found Page',
    path: '*',
    icon: <span className="material-symbols-rounded">attachment</span>
  }
} as const;

//Todo: type these...
const authenticatedPaths: TPathAuthenticated = {
  // SETTINGS: {
  //   title: 'Settings',
  //   path: '/settings',
  //   icon: <span className="material-symbols-rounded">settings</span>
  // },
  LOGOUT: {
    title: 'Logout',
    path: '/logout',
    icon: <span className="material-symbols-rounded">logout</span>
  }
} as const;

const merchantAuthenticatedPaths: TPathMerchantAuthenticated = {
  APPLICATIONS: {
    title: 'Applications',
    path: '/applications',
    icon: <span className="material-symbols-rounded">assignment</span>
  },
  SNPL: {
    title: 'Study Now Pay Later',
    path: '/snpl',
    icon: <span className="material-symbols-rounded">tab_recent</span>
  },
  PAYMENT_ASSIST: {
    title: 'Payment Assist',
    path: '/payment-assist',
    icon: <span className="material-symbols-rounded">payments</span>
  },
  COURSES: {
    title: 'Courses',
    path: '/courses',
    icon: <span className="material-symbols-rounded">view_list</span>
  },
  REPORTING: {
    title: 'Reporting',
    path: '/reporting',
    icon: <span className="material-symbols-rounded">insights</span>
  }
} as const;

const platformUserAuthenticatedPaths: TPathPlatformUserAAuthenticated = {
  ACCOUNTS: {
    title: 'Accounts',
    path: '/accounts',
    icon: <span className="material-symbols-rounded">folder</span>
  }
} as const;

const allPaths: TAllPaths = {
  ...merchantAdminPaths,
  ...platformAdminPaths,
  ...authenticatedPaths,
  ...merchantAuthenticatedPaths,
  ...platformUserAuthenticatedPaths,
  ...unAuthenticatedPaths
} as const;

export {
  authenticatedPathNames,
  unAuthenticatedPaths,
  authenticatedPaths,
  allPathNames,
  allPaths,
  merchantAdminPathNames,
  merchantAdminPaths,
  platformAdminPathNames,
  platformAdminPaths,
  type TPathUnauthenticated,
  type TAllPaths,
  type TPath,
  unAuthenticatedPathUrls,
  authenticatedPathUrls,
  allPathUrls
};
